import * as angular from 'angular';
import * as _ from 'lodash';

import { ItriggerService } from '../../services';
import { ITrigger as Trigger } from '../../models';
import { Store } from '../Store';
import * as TRIGGERS from './triggers.constants';

import {
    loadTriggers,
    loadTriggersSuccess,
    addTrigger,
    addTriggerSuccess,
    updateTriggerSuccess,
    updateTrigger,
    deleteTriggerSuccess,
    deleteTrigger
} from './triggers.actions';


export interface ITriggerActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<Trigger[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<Trigger[]>;
    addOne(target: Trigger): (dispatch: any, getState: () => Store) => angular.IPromise<Trigger>;
    updateOne(target: Trigger): (dispatch: any, getState: () => Store) => angular.IPromise<Trigger>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<Trigger>;
}

export class TriggersActionsService implements ITriggerActionsService {
    static serviceId = 'triggerActionsService';

    static $inject = ['$q', 'triggerService'];
    constructor(private _$q: angular.IQService,
        private _triggerService: ItriggerService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { triggers } = getState();
            if (force || (!triggers.isLoading && !triggers.isLoaded)) {
                dispatch(loadTriggers());
                return this._triggerService.getAll(force)
                    .then(data => {
                        dispatch(loadTriggersSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERS.TRIGGERS_LOAD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(_.values<Trigger>(triggers.dictionary));
            }
        };
    }

    addOne(trigger: Trigger) {
        return (dispatch: any, getState: () => Store) => {
            if (trigger) {
                dispatch(addTrigger(trigger));
                return this._triggerService.addOne(trigger)
                    .then(data => {
                        dispatch(addTriggerSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERS.TRIGGER_ADD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    updateOne(trigger: Trigger) {
        return (dispatch: any, getState: () => Store) => {
            if (trigger) {
                dispatch(updateTrigger(trigger));
                return this._triggerService.updateOne(trigger)
                    .then(data => {
                        dispatch(updateTriggerSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERS.TRIGGER_UPDATE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            if (guid) {
                dispatch(deleteTrigger(guid));
                return this._triggerService.deleteOne(guid)
                    .then(data => {
                        dispatch(deleteTriggerSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERS.TRIGGER_DELETE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }
}